import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { usePunchoutCataloguesLdFlags } from './launch-darkly'

export const useIsPunchoutCataloguesEnabled = () => {
  const { PUNCHOUT_CATALOGUES } = useFeatureFlags()
  const { SHOW_PUNCHOUT_CATALOGUES } = usePunchoutCataloguesLdFlags()

  return PUNCHOUT_CATALOGUES && SHOW_PUNCHOUT_CATALOGUES
}
